import React from 'react'
import './GameCard.css'


const GameCard = (props) => {
  return (
    <div className="main-zoom mt-2">
        <div className="img-zoom">
            <img src={props.poster} alt="zoome1" />
            <div className="overlay">
                <div className='btt'>
                <button>Play</button>
                </div>
            </div>
        </div>
        <h3 className='text-center text-white font-semibold text-[18px] mt-2'>{props.headening}</h3>
    </div>
  )
}

export default GameCard
